import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';

export default function save( props ) {
	const { attributes } = props;
	const { blockId } = attributes;
	const blockProps = useBlockProps.save( {
		className: `alpha-columns-blocks alpha-columns-block-${ blockId }`,
	} );
	return (
		<div { ...blockProps }>
			<InnerBlocks.Content />
		</div>
	);
}
